const config = {
  DEVELOPER_MODE: true, // set to false for production
SECRET_KEY: "F5gOom58ZOR6EgYrdOjrJCulxrJ26XHy",
  //API_BASE_URL: "https://sampark-api.cncicloud.com"
   API_BASE_URL: "https://cnci-appointment.cludocloud.com/api"
};

export default config;
